import { useEffect, useState } from "react";

import "./Range.css";

import type { CSSProperties, ChangeEvent, ReactNode } from "react";

export interface RangeChangeEvent {
  value: number;
}

export interface RangeProps {
  children?: ReactNode;
  value?: number;
  onChange?(event: RangeChangeEvent): void;
}

export function Range({ value, children, onChange }: RangeProps) {
  const [inputValue, setInputValue] = useState(0);

  const customProperties = {
    "--range-value-percent": `${inputValue}%`,
  } as CSSProperties;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    onChange?.({ value: newValue });
  };

  useEffect(() => {
    setInputValue(value ?? 0);
  }, [value]);

  return (
    <div className="Range" style={customProperties}>
      {children}
      <input
        value={value}
        max="100"
        min="0"
        step="1"
        type="range"
        onChange={handleChange}
      />
    </div>
  );
}
